import Validator from "./Validator";
import { User } from "@/types";

const PasswordValidator = ({ password }: Pick<User, "password">) => {
  if (!password) return;

  return (
    <Validator
      title="La contraseña debe tener al menos:"
      validations={[
        {
          label: "Entre 8 y 12 caracteres",
          isValid: password.trim().length >= 8,
        },
        {
          label: "Incluir al menos un número",
          isValid: /\d/.test(password),
        },
        {
          label: "Incluir al menos una mayúscula",
          isValid: /[A-Z]/.test(password),
        },
        {
          label: "Incluir al menos una minúscula",
          isValid: /[a-z]/.test(password),
        },
        {
          label: "Incluir al menos un símbolo especial",
          isValid: /[a-z]/.test(password),
        },
      ]}
    />
  );
};

export default PasswordValidator;
